<template>
  <div>
    <TheHeader @scroll-to-bottom="scrollToBottom" @change-section="updateSection"/>
    <main>
      <HeroSection/>
      <component :is="currentSection"></component>
    </main>
    <TheFooter/>
  </div>
</template>

<style scoped>

</style>
<script lang="ts">
// 引入所有需要的组件
import TheHeader from '../../components/TheHeader.vue';
import HeroSection from '../../components/HeroSection.vue';
import CategoriesSection from '../../components/CategoriesSection.vue';
import FeaturesSection from '../../components/FeaturesSection.vue';
import TheFooter from '../../components/TheFooter.vue';
import HomeContent from "../../components/HomeContent.vue";
import FindJobContent from '../../components/FindJobContent.vue'; // 找兼职内容

export default {
  name: 'HomeView',
  data() {
    return {
      // 默认显示 '首页' 的内容组件
      currentSection: 'HomeContent'
    };
  },
  components: {
    FindJobContent,
    HomeContent,
    TheHeader,
    HeroSection,
    CategoriesSection,
    FeaturesSection,
    TheFooter
  },
  methods: {
    /**
     * 将页面平滑滚动到页脚位置
     */
    scrollToBottom() {
      // 平滑滚动到底部
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      })
    },
    updateSection(sectionName) {
      // 切换当前显示的内容组件
      this.currentSection = sectionName;
    },
  }
}
</script>
